import { useEffect } from 'react'
import type { AgentFilterListWidget } from 'aevocam-rest-api-spec'
import { Button } from '@/components/action/Button'

type Props = {
  widget: AgentFilterListWidget
  fromStream?: boolean
  setArticleIds?: (articleIds?: string[]) => void
}

export function AgentFilterList({
  widget,
  fromStream,
  setArticleIds,
}: Props) {

  //--------------------------------------------------------------------------------
  function handleClick() {
    setArticleIds?.(widget?.articleIds)
  }

  //--------------------------------------------------------------------------------
  useEffect(() => {
    if (!fromStream) return
    handleClick()
  }, [fromStream]) // auto-apply once when mounted from a live stream turn

  //--------------------------------------------------------------------------------
  return (
    <Button
      label='Custom list'
      icon='chevronLeft'
      onClick={handleClick}
    />
  )
}
